import React from "react";

const Signup = () => {
  return <div>km,nm,nm,</div>;
};

export default Signup;
